import * as Mui from "@mui/material";
import React, { useContext } from "react";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import useSnackbar from "../../hooks/useSnackbar";
import { nameof } from "../common/ObjectUtils";
import FormInput from "../common/FormInput";
import { DriversTypes } from "./Types";
import { ContextOperation } from "../../context/OperationContext";
import { useForm } from "react-hook-form";
import DriversServer from "./service/drivers.action";
import GoogleAutocompleteWrapper from "../../../../util/component/GoogleAutocompleteWrapper";
import { CBGoogleAutocompleteType } from "../../../customerbase/types";

interface Props {
  open: boolean;
  onClose: () => void;
  updateDatasourceDamage: () => void;
}

const CreateDriver = (props: Props) => {
  const { setLoading } = useContext(ContextOperation);
  const snackbar = useSnackbar();
  const t = useOperationTranslation();
  const { tenant } = useContext(ContextOperation);
  const form = useForm<DriversTypes.Drivers>({
    defaultValues: {}
  });

  const onSubmit = () => {
    setLoading(true);
    DriversServer.create.createDriver(tenant, form.getValues()).then(
      () => {
        onClose();
        // if(props.formikValues){
        //   props.onReset();
        // }
        setLoading(false);
        snackbar.show("success", t("drivers.create.successMessages"));
      },
      (error: any) => {
        //onClose();
        setLoading(false);
        if (error.response.status == 409) {
          snackbar.show("error", t("drivers.create.licenseCodeError"));
        } else {
          snackbar.show("error", t("drivers.create.createError"));
        }
      }
    );
    // props.onReset();
  };

  const isDisabled = () => {
    let formValues = { ...form.getValues() };
    delete formValues?.fiscalCode;
    delete formValues?.mobile;
    return (
      JSON.stringify(formValues) == "{}" ||
      Object.values(formValues).some((x) => x == undefined || x?.trim() == "")
    );
  };

  const onClose = () => {
    props.onClose();
    form.reset();
  };

  return (
    <Mui.Card style={{ margin: "12px" }}>
      <>
        <Mui.Grid container alignItems="center">
          <Mui.Grid item xs="auto">
            <Mui.Typography
              variant="h6"
              pl={2}
              pt={2}
            >
              {t("drivers.create.title")}
            </Mui.Typography>
          </Mui.Grid>
        </Mui.Grid>
      </>
      <form id="damagePrice-list" onSubmit={form.handleSubmit(onSubmit)}>
        <Mui.Grid container spacing="16px" p={2}>
          <Mui.Grid item md={3} xs={12}>
            <FormInput
              type="text"
              label={t("drivers.fields.surname")}
              name={nameof<DriversTypes.Drivers>("surname")}
              formInstance={form}
              fullWidth
            />
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <FormInput
              type="text"
              label={t("drivers.fields.name")}
              name={nameof<DriversTypes.Drivers>("name")}
              formInstance={form}
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item md={3} xs={12}>
            <FormInput
              type="text"
              label={t("drivers.fields.fiscalCode")}
              name={nameof<DriversTypes.Drivers>("fiscalCode")}
              formInstance={form}
              fullWidth
            />
          </Mui.Grid>

          <Mui.Grid item md={3} xs={12}>
            <FormInput
              type="date"
              label={t("drivers.fields.birthDate")}
              name={nameof<DriversTypes.Drivers>("birthDate")}
              inputFormat={"DD/MM/YYYY"}
              removeTime={true}
              formInstance={form}
              fullWidth
            />
          </Mui.Grid>
        </Mui.Grid>

        <Mui.Grid container spacing="16px" p={2}>
          <Mui.Grid item md={3} xs={12}>
            <FormInput
              type="text"
              label={t("drivers.fields.address")}
              name={nameof<DriversTypes.Drivers>("address")}
              formInstance={form}
              fullWidth
            />
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <FormInput
              type="text"
              label={t("drivers.fields.birthNation")}
              name={nameof<DriversTypes.Drivers>("birthNation")}
              formInstance={form}
              fullWidth
            />
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <GoogleAutocompleteWrapper
              googleInputProps={
                {
                  options: {
                    types: ["address"]
                  },
                  onPlaceSelected: (place: any) => {
                    form.setValue("residenceAddress", place.formatted_address);
                    let country = place.address_components.find((a: any) => a.types.includes("country"))?.long_name;
                    form.setValue("countryResidence", country);
                  }
                }
              }
              inputProps={
                {
                  fullWidth: true,
                  label: t("drivers.fields.residenceAddress"),
                  name: `nameof<DriversTypes.Drivers>("residenceAddress")`,
                  type: "text",
                  value: form.watch("residenceAddress") || "",
                  onChange: (e) => {
                    form.setValue("residenceAddress", e.target.value);
                  }
                }
              }
            />
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <FormInput
              type="text"
              label={t("drivers.fields.countryResidence")}
              name={nameof<DriversTypes.Drivers>("countryResidence")}
              formInstance={form}
              fullWidth
            />
          </Mui.Grid>
        </Mui.Grid>
        <Mui.Grid container spacing="16px" p={2}>
          <Mui.Grid item md={3} xs={12}>
            <FormInput
              type="text"
              label={t("drivers.fields.drivingLicense")}
              name={nameof<DriversTypes.Drivers>("drivingLicenseNumber")}
              formInstance={form}
              fullWidth
            />
          </Mui.Grid>
          <Mui.Grid item md={3} xs={12}>
            <FormInput
              type="text"
              label={t("drivers.fields.mobile")}
              name={nameof<DriversTypes.Drivers>("mobile")}
              formInstance={form}
              fullWidth
            />
          </Mui.Grid>
          {/* <Mui.Grid item md={3} xs={12}>
            <FormInput
            type ="text"
             label={t("drivers.fields.sapDriverId")}
            name ={nameof<DriversTypes.Drivers>("sapDriverId")}
            formInstance={form}
            fullWidth/>
            </Mui.Grid> */}
        </Mui.Grid>
      </form>

      <>
        <Mui.Grid container justifyContent="end" spacing="16px" p={2}>
          <Mui.Grid item xs="auto">
            <Mui.Button variant="outlined" onClick={onClose}>
              {t(
                "vehicleEquipmentAssociation.dialogs.editAcriss.actions.cancel"
              )}
            </Mui.Button>
          </Mui.Grid>
          <Mui.Grid item xs="auto">
            <Mui.Button
              onClick={() => onSubmit()}
              disabled={isDisabled()}
            >
              {t("drivers.create.saveButton")}
            </Mui.Button>
          </Mui.Grid>
        </Mui.Grid>
      </>
    </Mui.Card>
  );
};

export default CreateDriver;
